import React from 'react';
import '../ThankYouPage/Styles.css'
import ContactSection from '../../components/ContactSectionPage/Index';
import useTitle from '../../useTitle';

const ThankYou = () => {
    useTitle("Thank You! Your Form Was Submitted")
  return (
    <>
    <div className='thankYouPageSectionContainer'>
        <div className='thankYouTitleContainer'>
            <h1 className='thankYouTitle'>Thank you for your message!</h1>
          </div>
        <div className='thankYouTitleDescription'>
            <p>Your message has been successfully received by Rico Vanhoutteghem.</p>
            <p>I will personally get back to you as soon as possible to answer your question or respond to your message.</p>
        </div>
        <div className='thankYouButtonContainer'>
            <button onClick={() => window.location.href = "/"} className='thankYouButton'>Go back to the Homepage</button>
        </div>
    </div>
    <ContactSection />
    </>
  )
}

export default ThankYou;
